<template>
  <div class="Wx-home">
    <div class="header">
      <navhead @onGlobalSwitchLang="onGlobalSwitchLang" />
    </div>
    <div class="routerSwitch" >
      <nav-menu @debit="debounce_debit" />
      <div class="main" :class="collapsed ? 'debit_webmain' : 'webmain'" ref="DomHeight">
        <router-view v-if='limits' />
        <Empty v-if='!limits' :imgRequire="require('@/assets/Frame113160.png')"  height="90vh">暂无权限</Empty>
      </div>
    </div>
  </div>
</template>

<script setup>

import Empty from '@/components/home/empty/empty'
import { getCurrentInstance, onMounted, onBeforeUnmount, onUnmounted, ref } from "vue";
import navhead from "@/components/wx-Nav-header";
import navMenu from "@/components/wx-menu";
import { UpdataDomHeight } from "@/utils/Session";
import { debounce } from "lodash";
const { $eventBus } = getCurrentInstance().appContext.config.globalProperties
const limits = ref(true); //无菜单时不显示页面  显示无权限
const DomHeight = ref(null);
onMounted(() => {
  UpdataDomHeight('DomHeight',DomHeight.value.clientHeight);
  // 监听窗口变化
  window.addEventListener('resize', getheight, false);
  // console.log(onMounted);
  $eventBus.on('limits_isShow',(blo) => {
    // console.log(blo,1000);
    limits.value = blo
  })
});
const emit = defineEmits(["onGlobalSwitchLang"])

const onGlobalSwitchLang = () => {
  emit("onGlobalSwitchLang")
}
const collapsed = ref(false);

function debounce_debit(event) {
  // 64
  collapsed.value = event;
}

import { useI18n } from "vue-i18n";
const { t } = useI18n();

 window.BtnStayPage = t('Course.StayPage')
  window.BtnExitPage = t('Course.ExitPage')


function getheight(){
  UpdataDomHeight('DomHeight',DomHeight.value.clientHeight);
}
onBeforeUnmount(()=>{
  window.removeEventListener('resize', getheight, false)
})
onUnmounted(() => {
  // 移除监听事件
  $eventBus.off('limits_isShow')
  // console.log("组件实例被销毁了");
});
</script>

<style lang="less" scoped>
.Wx-home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    width: 100%;
  }
  .routerSwitch {
    padding: 20px 30px;
    box-sizing: border-box;
    // flex: 1;
    height: calc(100% - 56px);
    display: flex;
    gap: 29px;
    .webmain {
      width: calc(100% - 232px);
    }
    .debit_webmain {
      width: calc(100% - 64px);
    }
    .main {
      height: 100%;
      border-radius: 6px;
      background: var(--Gray-White);
      overflow: hidden;
      transition: width 0.3s;
    }
  }
}
</style>
